export default {
  home: '/',
  otp: '/otp',
  dashboard: '/dashboard',
  investor: '/investor',
  investorList: '/investor/list',
  deposit: '/investor/deposit',
  addDeposit: '/investor/deposit/add',
  withdrawal: '/investor/withdrawal',
  addWithdrawal: '/investor/withdrawal/add',
  investorRecorder: '/investor/cashFlowList',
  investorRecorderDetails: '/investor/cashFlowList/details',
  manageUsersList: '/investor/manageUsers',
  serviceFeeRebateList: '/investor/serviceFeeRebateList',
  investorTransactionReport: '/investor/investorTransactionReport',
  kycReport: '/investor/kycReport',
  portfolio: '/portfolio',
  portfolioType: '/portfolio/portfolioType',
  portfolioByInvoice: '/portfolio/byInvoice',
  portfolioByInvoiceView: '/portfolio/byInvoice/view',
  portfolioByTermLoan: '/portfolio/byTermLoan',
  investmentNoteEmail: '/portfolio/investmentNoteEmail',
  autoInvest: '/autoInvest',
  autoInvestByInvoice: '/autoInvest/byInvoice',
  autoInvestByTermLoan: '/autoInvest/byTermLoan',
  autoInvestExclusionList: '/autoInvest/exclusionList',
  autoInvestSpecialAllocation: '/autoInvest/specialAllocation',
  autoInvestInternalFunding: '/autoInvest/internalFunding',
  otherTransaction: '/otherTransaction',
  otherTransactionList: '/otherTransaction/list',
  otherTransactionManage: '/otherTransaction/manage',
  ledger: '/ledger',
  introducer: '/introducer',
  introducerList: '/introducer/list',
  introducerGroupList: '/introducer/introducerCompanyList',
  introducerReferralCode: '/introducer/introducerReferralCode',
  referralCodeList: '/introducer/referralCodeList',
  pageNotFound: '*',
  poc: '/poc',
  resetPassword: '/resetPassword',
  statement: '/statement',
  statementRelease: '/statement/statement-release',
  upcomingStatement: '/statement/statement-release/upcoming',
  releasedStatement: '/statement/statement-release/released',
  generateStatement: '/statement/generate',
  commentTemplateList: '/comment-template',
  gradingLimitsList: '/grading-limits',
  secondaryMarketTransactionsList: '/secondary-market-transactions',
  eInvoice: '/e-invoice',
};
